// extracted by mini-css-extract-plugin
module.exports = {"sourceDetailModal":"transactiondetail_sourceDetailModal__BhYu6"};